/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

const GlobalSpinner = props => {
  if (props.loading) return <div className="global-spinner" />;

  return null;
};

const mapStateToProps = (state) => {

  const tasksSending = state.taskReducer.isSending;
  const workPackagesSending = state.workPackageReducer.isSending;
  const teamSending = state.teamReducer.isSending;
  const { roleChanging } = state.teamReducer;
  const { activeSpacesSpinner } = state.userReducer;
  const savedViewFetching = state.savedViewReducer.isFetching;
  const targetSending = state.targetReducer.isSending;
  return {
    loading:
      tasksSending ||
      workPackagesSending ||
      teamSending ||
      activeSpacesSpinner ||
      roleChanging ||
      savedViewFetching ||
      targetSending
  };
};

export default withRouter(connect(mapStateToProps)(GlobalSpinner));
